import React, { Component } from 'react'
import { Button } from 'stylist'

class ZendeskSupportButton extends Component {
  componentWillMount() {
    const { zendeskHost, message } = this.props
    window.initZe(zendeskHost, message)
  }

  render() {
    return (
      <Button
        onClick={() => window.zE(() => window.zE.activate())}
        {...this.props}
      >
        Contact Helpdesk
      </Button>
    )
  }
}

export default ZendeskSupportButton



// WEBPACK FOOTER //
// ./src/routes/errors/components/ZendeskSupportButton.js